export const pricePerNightPerPersonCounter = (
  minPrice: number,
  adults: number,
  kidsCount: number,
  nights: number,
): number =>
  minPrice ? Math.round(minPrice / (adults + kidsCount) / nights) : 0;
